export default __webpack_public_path__ + "static/media/logoPadelAdmin2.04cdb882.svg";